import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

export interface NewWorkflowState {
  selectedWorkflowDefinitionId: string | null;
}

const initialState: NewWorkflowState = {
  selectedWorkflowDefinitionId: null,
};

export const newWorkflowSlice = createSlice({
  name: "newWorkflow",
  initialState,
  reducers: {
    closeNewWorkflow: (state) => {
      state.selectedWorkflowDefinitionId = null;
    },
    setSelectedWorkflowDefinitionId: (
      state,
      action: PayloadAction<string | null>
    ) => {
      state.selectedWorkflowDefinitionId = action.payload;
    },
  },
});

export const { closeNewWorkflow, setSelectedWorkflowDefinitionId } =
  newWorkflowSlice.actions;

export function selectSelectedWorkflowDefinitionId(state: {
  newWorkflow: NewWorkflowState;
}) {
  return state.newWorkflow.selectedWorkflowDefinitionId;
}
